import { fechaMinimaHasta } from "../../utils/funciones";
import { HeadInput } from "../ui/HeadInput";
import PropTypes from "prop-types";
import moment from "moment";

const FormDatosNacionalidadExtranjera = ({ formik, txtTipoVisa }) => {
  
  return (
    <>
      <hr />
      {formik.values.tipoVisa === "2" && (
        <div className="alert alert-warning d-flex align-items-center" role="alert">
          <div>
            Si es Visa Sujeta a Contrato, no es posible generar la solicitud.
          </div>
        </div>
      )}
      <div className="row mt-3">
        <div className="col-12 col-sm-6 my-1">
          <HeadInput label="Tipo de visa *" formik={formik} html_for="tipoVisa" datosObj="datosPersonaExtranjera" />
          <select
            className="form-select"
            name="datosPersonaExtranjera.tipoVisa"
            aria-label="Default select example"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.datosPersonaExtranjera.tipoVisa}
          >
            <option value="">Seleccione</option>
            <option value="1">Definitiva</option>
            <option value="2">Temporaria</option>
          </select>
        </div>

        {(formik.values.datosPersonaExtranjera.tipoVisa !== "" && formik.values.datosPersonaExtranjera.tipoVisa !== 0) && (
          <div className="col-12 col-sm-6 my-1">
            <HeadInput label={`Visa ${txtTipoVisa} desde *`} formik={formik} html_for="visaTemporariaDesde" datosObj="datosPersonaExtranjera" />
            <input
              type="date"
              min={moment(new Date()).subtract('y', 20).format('yyyy-MM-DD')}
              max={moment(new Date()).format('yyyy-MM-DD')}
              name="datosPersonaExtranjera.visaTemporariaDesde"
              className="form-control"
              onChange={
                (e) => { formik.setFieldValue('datosPersonaExtranjera.visaTemporariaDesde', e.target.value); }
              }
              onBlur={formik.handleBlur}
              value={formik.values.datosPersonaExtranjera.visaTemporariaDesde}
            />
          </div>
        )}
      </div>

      {(formik.values.datosPersonaExtranjera.tipoVisa !== "" && formik.values.datosPersonaExtranjera.tipoVisa !== 0) && (
        <div className="row mt-3">
          <div className="col-12 col-sm-6 my-1">
            <HeadInput label={`Visa ${txtTipoVisa} hasta *`} formik={formik} html_for="visaTemporariaHasta" datosObj="datosPersonaExtranjera" />
            <input
              type="date"
              max="9999-12-31"
              min={fechaMinimaHasta(formik.values.datosPersonaExtranjera.visaTemporariaDesde)}
              name="datosPersonaExtranjera.visaTemporariaHasta"
              className="form-control"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.datosPersonaExtranjera.visaTemporariaHasta}
            />
          </div>
        </div>
      )}
      {moment(formik.values.datosPersonaExtranjera.visaTemporariaHasta).diff(
        moment(formik.values.datosPersonaExtranjera.visaTemporariaDesde),
        "month"
      ) < 3 && (
          <div className="alert alert-warning d-flex align-items-center my-3" role="alert">
            <div>
              La vigencia de visa es menor a 3 meses, en el formulario de documentos se debe adjuntar documento de trámite de permanencia definitiva y/o renovación de visa emitido por extranjería.
            </div>
          </div>
        )}
    </>
  );
};

FormDatosNacionalidadExtranjera.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      tipoVisa: PropTypes.string,
      datosPersonaExtranjera: PropTypes.shape({
        tipoVisa: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        visaTemporariaDesde: PropTypes.string,
        visaTemporariaHasta: PropTypes.string,
      }),
    }).isRequired,
    errors: PropTypes.shape({
      datosPersonaExtranjera: PropTypes.shape({
        tipoVisa: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        visaTemporariaDesde: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        visaTemporariaHasta: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      }),
    }),
    touched: PropTypes.shape({
      datosPersonaExtranjera: PropTypes.shape({
        tipoVisa: PropTypes.bool,
        visaTemporariaDesde: PropTypes.bool,
        visaTemporariaHasta: PropTypes.bool,
      }),
    }),
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  txtTipoVisa: PropTypes.string,
};

export default FormDatosNacionalidadExtranjera;
